export default "__VITE_ASSET__PGpFEhA5__"